import script from "./CategoryBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryBox.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryBox.vue?vue&type=style&index=0&id=5b39b079&lang=css"

const __exports__ = script;

export default __exports__